import Vue from "vue"
import Router from "vue-router"

Vue.use(Router)

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "index",
      component: () => import("./views/Home.vue")
    },
    {
      path: "/you",
      name: "you",
      component: () => import("./views/You.vue")
    },
    {
      path: "/type",
      name: "type",
      component: () => import("./views/Type.vue")
    },
    {
      path: "/new",
      name: "new",
      component: () => import("./views/New.vue")
    },
    {
      path: "/designer",
      name: "designer",
      component: () => import("./views/New2.vue")
    },
    {
      path: "/extras",
      name: "extras",
      component: () => import("./views/New3.vue")
    },
    {
      path: "/summary",
      name: "summary",
      component: () => import("./views/Summary.vue")
    },
    {
      path: "/new-memorial/:id",
      name: "new-memorial",
      component: () => import("./views/Summary.vue")
    },
    {
      path: "/rennovation",
      name: "rennovation",
      component: () => import("./views/Rennovation.vue")
    },
    {
      path: "/rennovation/:id",
      name: "get-rennovation",
      component: () => import("./views/Rennovation.vue")
    },
    {
      path: "/inscription",
      name: "inscription",
      component: () => import("./views/Inscription.vue")
    },
    {
      path: "/inscription/:id",
      name: "get-inscription",
      component: () => import("./views/Inscription.vue")
    },
    {
      path: "/thankyou",
      name: "thankyou",
      component: () => import("./views/Thankyou.vue")
    },
    {
      path: "/started",
      name: "started",
      component: () => import("./views/Started.vue")
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
